import { render, staticRenderFns } from "./DanhGiaKDLForm.vue?vue&type=template&id=e25c61c6&"
import script from "./DanhGiaKDLForm.vue?vue&type=script&lang=js&"
export * from "./DanhGiaKDLForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports